/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useEffect } from "react";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { json } from "../../../../../assets/data/coords";
import { locationSvg } from "../../../../../assets/icons";
import { ambassadors } from "../../../../../assets/data/ambassadors";
import { Team } from "../../../../Teams/teams";

interface Globe3dProps {
  teams: Team[];
}
const getFloatValue = (value: string): string =>
  Number.parseFloat(value).toFixed(6);

export const Globe3d = (props: Globe3dProps): JSX.Element => {
  const { teams } = props;
  const canvas: HTMLCanvasElement | null = document.querySelector(".canvas");
  const isMobileSize = window.innerWidth < 750;
  const isTabletSize = window.innerWidth < 900 && !isMobileSize;
  const renderer = new THREE.WebGLRenderer({
    antialias: true,
    alpha: true,
    canvas: canvas !== null ? canvas : undefined,
  });
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.setClearColor(0x000000, 0);
  renderer.outputEncoding = THREE.sRGBEncoding;

  const scene = new THREE.Scene();

  const camera = new THREE.PerspectiveCamera(40, 1, 1, 2000);
  camera.aspect = 1;
  if (isMobileSize || isTabletSize) {
    camera.position.set(0, 0, 2000);
  } else {
    camera.position.set(100, 700, 2000);
  }
  camera.zoom = isMobileSize || isTabletSize ? 4 : 2.3;

  const controls = new OrbitControls(camera, renderer.domElement);
  controls.target.set(0, 0, 0);
  controls.update();
  controls.enableZoom = false;
  controls.autoRotate = true;
  controls.autoRotateSpeed = 0.2;

  const teamsCoordinates: {
    lat: string;
    long: string;
    id: string;
  }[] = teams.map((team) => ({
    lat: getFloatValue(team.Latitude),
    long: getFloatValue(team.Longitude),
    id: team.Name,
  }));

  const ambassadorsCoordinates: {
    lat: string;
    long: string;
    id: string;
  }[] = ambassadors.map((ambassador) => ({
    id: ambassador.Name,
    lat: getFloatValue(ambassador.Latitude.toString()),
    long: getFloatValue(ambassador.Longitude.toString()),
  }));

  const vector = new THREE.Vector3();

  const findSphericalCoords = (
    coord: number[] | string[],
    type: string
  ): number[] => {
    if (type === "points") {
      const x =
        typeof coord[0] === "number" ? coord[0] : Number.parseFloat(coord[0]);
      const y =
        typeof coord[1] === "number" ? coord[1] : Number.parseFloat(coord[1]);
      const phi = (x * Math.PI) / 180 + Math.PI / 2;
      const theta = (y * Math.PI) / 180 + Math.PI;
      vector.setFromSphericalCoords(-300.5, phi, theta);
      return [vector.x, vector.y, vector.z];
    }
    const x =
      typeof coord[0] === "number" ? coord[0] : Number.parseFloat(coord[0]);
    const y =
      typeof coord[1] === "number" ? coord[1] : Number.parseFloat(coord[1]);
    const phi = (x * Math.PI) / 180 + Math.PI / 2;
    const theta = (y * Math.PI) / 180 + Math.PI;
    vector.setFromSphericalCoords(-300, phi, theta);
    return [vector.x, vector.y, vector.z];
  };

  const gl = renderer.getContext();

  const createPointsBuffer = (
    coords: number[][],
    color: string,
    type: string
  ) => {
    const geometry = new THREE.BufferGeometry();

    const pos = gl.createBuffer();
    const coordinates: number[] = [];
    for (const coord of coords) {
      coordinates.push(...findSphericalCoords(coord, "points"));
    }
    gl.bindBuffer(gl.ARRAY_BUFFER, pos);
    gl.bufferData(
      gl.ARRAY_BUFFER,
      new Float32Array(coordinates),
      gl.STATIC_DRAW
    );
    const posAttr1 = new THREE.GLBufferAttribute(
      // @ts-expect-error no type
      pos,
      gl.FLOAT,
      3,
      4,
      coords.length
    );

    // @ts-expect-error no type
    geometry.setAttribute("position", posAttr1);
    const texture = new THREE.TextureLoader().load(locationSvg);
    const material =
      type === "points"
        ? new THREE.PointsMaterial({ size: isMobileSize ? 6 : 8, color })
        : new THREE.PointsMaterial({
            size: 10,
            map: texture,
            transparent: true,
          });
    const points = new THREE.Points(geometry, material);
    points.frustumCulled = false;
    return points;
  };
  const mainPoints = createPointsBuffer(json.coords, "#2d3e66", "points");

  const setPoints = (
    coordinates: { lat: string; long: string; id: string }[],
    color: string
  ) => {
    const points = new THREE.Object3D();

    for (const coord of coordinates) {
     const material = new THREE.MeshPhongMaterial({ color, emissive: color, emissiveIntensity: 0.7 });
     const geometry = new THREE.IcosahedronGeometry(isMobileSize ? 2.7 : 3, 1);
     // const colorObj = new THREE.Color(color);
     // geometry.setAttribute('color', colorObj);
      const mesh = new THREE.Mesh(geometry, material);
      const coords: string[] = [coord.lat, coord.long];
      const coordsSpherical = findSphericalCoords(coords, "team");
      mesh.position.set(
        coordsSpherical[0],
        coordsSpherical[1],
        coordsSpherical[2]
      );
      mesh.name = coord.id.toString();
      points.add(mesh);
    }

    return points;
  };
  const teamPoints = setPoints(teamsCoordinates, "#40cc7f");
  const ambassadorPoints = setPoints(ambassadorsCoordinates, "#bf2359");

  const globe = new THREE.IcosahedronGeometry(300, 10);
  const color = new THREE.Color().setHex(0x2a3e80);
  const globeMaterial = new THREE.MeshLambertMaterial({
    color,
    side: THREE.DoubleSide,
  });
  const globeMesh = new THREE.Mesh(globe, globeMaterial);

  const directionalLight = new THREE.DirectionalLight(0xffffff, 0.15);
  directionalLight.position.set(-4000, 8000, 3000);
  directionalLight.position.normalize();

  function onWindowResize() {
    const isMobile = window.innerWidth < 750;
    const isTablet = window.innerWidth < 900 && !isMobileSize;
    if (isMobile) {
      teamPoints.scale.set(0.5, 0.5, 0.5);
      ambassadorPoints.scale.set(0.5, 0.5, 0.5);
      mainPoints.scale.set(0.5, 0.5, 0.5);
      globeMesh.scale.set(0.497, 0.497, 0.497);
    } else if (isTablet) {
      teamPoints.scale.set(0.75, 0.75, 0.75);
      ambassadorPoints.scale.set(0.75, 0.75, 0.75);
      mainPoints.scale.set(0.75, 0.75, 0.75);
      globeMesh.scale.set(0.75, 0.75, 0.75);
    } else {
      teamPoints.scale.set(1, 1, 1);
      ambassadorPoints.scale.set(1, 1, 1);
      mainPoints.scale.set(1, 1, 1);
      globeMesh.scale.set(1, 1, 1);
    }

    renderer.setSize(
      window.innerWidth / (isMobile ? 1.2 : isTablet ? 1.2 : 1.6),
      window.innerHeight / (isMobile ? 1.2 : isTablet ? 1.2 : 1.6)
    );

    if (isMobileSize || isTabletSize) {
      camera.position.set(0, 0, 2000);
    } else {
      camera.position.set(100, 700, 2000);
    }
    camera.zoom = isMobileSize || isTabletSize ? 4 : 2.3;
    camera.aspect = 1;
    camera.updateProjectionMatrix();
  }

  window.addEventListener("resize", onWindowResize, false);
  window.dispatchEvent(new Event("resize"));
  const pivot = new THREE.Group();
  scene.add(pivot);
  pivot.add(teamPoints);
  scene.add(mainPoints);
  scene.add(ambassadorPoints);
  scene.add(globeMesh);
  scene.add(directionalLight);

  function positionTip(pos3D: THREE.Vector3, tooltip: Element) {
    const v = pos3D.project(camera);
    const left = (window.innerWidth * (v.x + 1)) / 2;
    const top = (window.innerHeight * (-v.y + 1)) / 2;
    tooltip.setAttribute(
      "style",
      `display:block; position:absolute; left: ${left}; top: ${top}`
    );
  }

  const mouse = new THREE.Vector2();
  const objects = [teamPoints];
  function onMouseMove(event: { clientX: number; clientY: number }) {
    const rect = renderer.domElement.getBoundingClientRect();
    mouse.x = ((event.clientX - rect.left) / (rect.right - rect.left)) * 2 - 1;
    mouse.y = -((event.clientY - rect.top) / (rect.bottom - rect.top)) * 2 + 1;
    const vectorMouse = new THREE.Vector3(mouse.x, mouse.y, 0.5).unproject(
      camera
    );
    const raycaster = new THREE.Raycaster(
      camera.position,
      vectorMouse.sub(camera.position).normalize(),
      undefined,
      undefined
    );
    const intersects = raycaster.intersectObjects(objects, true);
    for (const intersect of intersects) {
      const tooltip = document.querySelector("#tip");
      if (tooltip) {
        tooltip.setAttribute("style", "display:block; position:absolute");
        tooltip.innerHTML = intersect.object.name;
        positionTip(intersect.object.position, tooltip);
      }
    }
  }
  window.addEventListener("click", onMouseMove, false);
  const animate = () => {
    requestAnimationFrame(() => animate());
    controls.update();
    renderer.render(scene, camera);
  };
  useEffect(() => {
    animate();
  }, [animate]);

  return (
    <div className="globe-canvas">
      <canvas className="canvas" />
      {/* <div id="tip" style={{"position": "absolute", "display": "none"}}>Some text</div> */}
    </div>
  );
};
